import {
  Box,
  Button,
  Fab,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import Grid from "@mui/material/Grid";
import SettingsIcon from '@mui/icons-material/Settings';
import React, { useEffect, useState } from "react";
import { getAllOffer, getBulkWhatsappMessage, getMessageCount } from "./apiFunction";
import Card from "./card";
import CardEle from "./card";
import PopUp from "./PopUp";
import AddIcon from "@mui/icons-material/Add";
import PopUpWp from "./PopUpWp";
import { PaginationCm } from "../../common/pagination";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import { Filter } from "../../common/fiterComp";
import MessagePopup from "./MessagePopup";

export default function BulkMessage({ }) {
  const [numberOfPage, setnumberOfpages] = useState(1);
  const [collection, setColletion] = useState([]);
  const [setting, setSetting] = useState();

  const [collectionCredit, setCollectionCredit] = useState([]);

  const get = () => {
    getMessageCount((data) => {
      console.log("what app count", data?.data?.data);

      if (data?.data?.data?.totalCount <= 10) {
        Swal.fire({
          title: "Credits are about to end",

          text: "Recharge soon to continue service",
          icon: "warning",

          // ...swalAlertPopProps,
          // timer: 2000,
          // Adj
        });
      }

      setCollectionCredit(data?.data?.data);
    });
    getAllOffer((data) => {
      console.log("Salon/GetAllOffers ", data?.data);
      setColletion(data?.data?.list);
    });
  };

  useEffect(() => {
    getAllOffer((data) => {
      console.log("Salon/GetAllOffers ", data?.data);
      setColletion(data?.data?.list);
    });

    get();
  }, []);
  useEffect(() => {
    
    getBulkWhatsappMessage((data) => {
      console.log("Salon/whatsappSetting ", data?.data);
      setSetting(data?.data?.data);
    });
   
  }, []);
  const [open, setOpen] = useState(false);
  const [opent, setOpent] = useState(false);

  const [getDataPayload, setGetDataPykoad] = useState({
    page: 1,
    pageSize: 1000,
    filter: "",
    search: "",
    filter2: "",
    search2: "",
  });
  const [data, setData] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);

  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={{ sm: 4, xs: 2 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
          minHeight: "100vh",
        }}
      >
        {/* <Grid
          item
          xs={12}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B", // optional text color
            textAlign: "left",
            marginBottom: "20px",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          <Typography variant="h6">Bulk Message</Typography>
        </Grid> */}

        <Grid container alignItems="center" sx={{ mt: "10px", mb: "20px" }}>
          {/* Heading */}
          <Grid
            item
            xs={12}
            sm={8}
            md={10}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              borderRadius: "5px",
              color: "#01008B",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "20px",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Bulk Messages
            </Typography>
          </Grid>

          {/* Button */}
          <Grid
            item
            md={2}
            sm={4}
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mt: { xs: "12px", md: "0px", sm: "0px" },
            }}
          >
            <Button
              variant="contained"
              fullWidth
              sx={{
                height: "40px",
                backgroundColor: "#14008B",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
              endIcon={<SettingsIcon />}
              onClick={() => setOpenPopup(true)}
            >
              Settings
            </Button>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid
            container
            spacing={2}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Grid item xs={12} md={8} lg={9}>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  padding: "10px 15px",
                  borderRadius: "5px",
                  border: "1px solid #01008B",
                  height: "20px",
                }}
              >
                <Typography
                  variant="standard"
                  component={"h4"}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography
                    component="span"
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Your Credit Messages :
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      color: "primary.main",
                      fontWeight: 600,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    {collectionCredit?.totalCount}
                  </Typography>
                </Typography>
              </Box>
            </Grid>

            <Grid
              item
              md={4}
              lg={3}
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="contained"
                fullWidth
                sx={{
                  height: "40px",
                  backgroundColor: "#14008B",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
                endIcon={<AddIcon />}
                onClick={() => {
                  setData(null);
                  setOpen(true);
                }}
              >
                Add New Message
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          mt={4}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "10px",
          }}
        >
          <Grid container>
            <Grid item xs={12} sx={{ height: "70vh", overflow: "auto" }}>
              <Grid container spacing={2} sx={{ padding: "10px" }}>
                {collection.map((ele, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <CardEle
                      item={ele}
                      callback={() => {
                        setOpen(true);
                        setData(ele);
                      }}
                      cbt={() => {
                        setOpent(true);
                        setData(ele);
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <PopUp callbackGetMsg={get} open={open} setOpen={setOpen} data={data} />

        <PopUpWp
          open={opent}
          callbackGetMsg={() => {
            get();
          }}
          countCredit={collectionCredit?.totalCount}
          setOpen={setOpent}
          data={data}
          feature={"bulkupload"}
        />

        <MessagePopup
          setting={setting}
          open={openPopup}
          handleClose={() => setOpenPopup(false)}
        />
      </Box>
    </>
  );
}
